const filterTextsData = ( data ) => {
  const filteredData = data.allFile.edges[0].node.internal.content
  return JSON.parse(filteredData)
}

export default filterTextsData